import { Component, Input, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
    selector: 'calculation-row',
    templateUrl: './calculation-row.component.html',
    styleUrls: ['./calculation-row.component.scss']
})
export class CalculationRowComponent extends BaseWithBundleComponent
                                     implements OnInit {

    @Input()
    public label: string;

    @Input()
    public val_1: number;

    @Input()
    public val_2?: number;

    @Input()
    public negative?: boolean;

    @Input()
    public colored?: boolean;

    @Input()
    public bold?: boolean;

    @Input()
    public underline?: boolean;

    get showSecondValueColumn(): boolean {
        return !!(this.val_2 || this.val_2 === 0);
    }

    constructor(componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
    }

    public ngOnInit() {
    }
}
